function ivuUploadMeterReadingImageOnFileSelect(
    fileInputId,
    controllerUrl,
    imageType,
    imageKey,
    executionKey,
    errorMessage
) {
    jQuery("#" + fileInputId).on("fileselect", function () {
        var input = document.getElementById(fileInputId);
        if (!input || !input.files || input.files.length === 0) {
            return;
        }
        var formData = new FormData();
        formData.append("files", input.files[0]);
        formData.append("imageType", imageType);
        formData.append("imageKey", imageKey);
        formData.append("execution", executionKey);
        jQuery.ajax({
            url: controllerUrl,
            type: "POST",
            data: formData,
            processData: false,
            contentType: false,
            success: function (data) {
                if (data.success) {
                    updateFlowContent(jQuery("#" + fileInputId), {
                        eventId: "updateImageUpload",
                        fragment: "content"
                    });
                } else {
                    alert(errorMessage);
                }
            },
            error: function () {
                alert(errorMessage);
            }
        });
    });
}
